import { Injectable } from '@angular/core';
import { ProgramVm, ResourceVm } from 'qp-ui-interface';
import { UnivisionEntitlement } from '../models/Entitlements';
import { AdobeService } from '../services/adobe/adobe.service';
import { LocalStorageService } from '../services/local-storage/local-storage.service';
import { QPATService } from '../services/qpat/qpat.service';
import { isLoggedIn } from '../utils/LoginUtils';

@Injectable({
  providedIn: 'root',
})
export class EntitlementService {
  constructor(private adobeService: AdobeService, private localStorage: LocalStorageService, private qpatService: QPATService) {}

  /**
   * Validate if the user is enttitled to see the resource
   * @param subscriptionPackage
   * @returns
   */
  async isUserEntitledResource(resource: ResourceVm): Promise<boolean> {
    const packages = resource.entitlement[0].subscriptionPackage;
    return this.isUserEntitled(packages);
  }

  /**
   * Validate if the user is enttitled to see the epg program
   * @param subscriptionPackage
   * @returns
   */
  async isUserEntitledProgram(resource: ProgramVm): Promise<boolean> {
    const packages = resource.entitlement[0].subscriptionPackage;
    return this.isUserEntitled(packages);
  }

  /**
   * Validate if the user is enttitled to see the content based in the subscription package
   * @param subscriptionPackage
   * @returns
   */
  async isUserEntitled(subscriptionPackage: string[]): Promise<boolean> {
    // Check dtc vip user
    const isVipUser = await this.isVipUser();
    if (isVipUser) return true;
    const userEntitledPackagesNames = await this.getUserEntitlementPackages();
    // Check for free entitlements
    if (this.isContentFree(subscriptionPackage)) return true;
    // If the user is logged in
    if (isLoggedIn(this.localStorage) && userEntitledPackagesNames && userEntitledPackagesNames.length > 0) {
      // Return if at least one package of user entitlement is included in the resource subscription package
      return userEntitledPackagesNames.some((element) => subscriptionPackage.includes(element));
    }

    return false; // Return false if not logged in
  }

  isContentFree(contentPackages: string[]): boolean {
    // Check for free entitlements
    if (
      contentPackages.includes(UnivisionEntitlement.FREE_DTC) ||
      contentPackages.includes(UnivisionEntitlement.FREE_TVE) ||
      contentPackages.includes(UnivisionEntitlement.FREE)
    ) {
      return true;
    }
    return false;
  }

  async getUserEntitlementPackages(): Promise<string[]> {
    if (isLoggedIn(this.localStorage)) {
      const qpat = this.qpatService.getQPAT();
      if (!qpat) return [UnivisionEntitlement.BLOCKED];
      if (this.adobeService.fullEntitlementPackages) return this.adobeService.fullEntitlementPackages;
    }
    return [UnivisionEntitlement.FREE_TVE];
  }

  async isVipUser(): Promise<boolean> {
    return false;
  }
}
